import { getTagError, getTagMetadata } from './analytics';

export const callAnalyticsError = (error) => {
  const { code, message, endpoint } = error;
  const withAuditoryDigitalData = () => {};
  if (endpoint !== '') {
    withAuditoryDigitalData({
      code,
      error: message,
      endpoint,
      urlPageError: '004',
      urlClient: window.location.href,
      pathClient: window.location.pathname,
    });
  }

  getTagError(code, message, endpoint);
};

export const callAnalyticsMetadata = (key, value) => {
  getTagMetadata(key, value, 'trackMetadata');
};
